import Vue from 'vue';
import VueRouter from 'vue-router';
import {routers} from './router';
import {menuRouteHelper} from '../lib/utils';
import config from '@/config'
import store from '@/store'
import { $http, $util } from '@/lib';
import { LoadingBar } from "view-design"
const { homeName, enableSSO } = config

Vue.use(VueRouter);

const router = new VueRouter({
    //mode: 'history',
    routes: routers
});

const LOGIN_PAGE_NAME = 'login'
  
const turnTo:Function = (to:any,next:any) => {
    if (menuRouteHelper.canDirectlyTurnTo(to)) next() // 有权限，可访问
    else next({ replace: true, name: 'error_401' }) // 无权限，重定向到401页面
}

const initCurrentUser:Function = (to:any, next:any, callback:Function) => {
    if (store.state["currentUser"]["hasInit"]) {
        callback();
    } else {
        $http.get('Authenticate/GetUserInfo').then(async rep => {
            store.commit("currentUser/setSession", rep.data.result.session);
            store.commit("currentUser/setPermissionList", rep.data.result.permissionList);
            $util.basic.auth.permissionList = rep.data.result.permissionList;
            // 是否为业务组负责人，在这里请求，目的防止其他页面Created或者mounted无法及时抓取该值
            await store.dispatch("system/user/isBusinessGroupHead");
            callback()
        }).catch(() => {
            window.basic.utils.clearToken();
            next({
                name: 'login'
            })
        })
    }
}
  
router.beforeEach((to, from, next) => {
    LoadingBar.start()
    const token = window.basic.utils.getToken()
    if (!token && to.name !== LOGIN_PAGE_NAME && ( !enableSSO || (enableSSO && (process.env.NODE_ENV === "development" || (process.env.NODE_ENV === "production" && process.env.VUE_APP_ENABLE_SSO === "false"))))) {
        // 未登录且要跳转的页面不是登录页
        // 跳转到登录页 
        next({ name: LOGIN_PAGE_NAME});
    } else if( enableSSO && !token && to.name !== "main" && to.name !== "home" && process.env.NODE_ENV === "production"  && process.env.VUE_APP_ENABLE_SSO === "true"){
        //production环境 sso 直接跳转至 home
        next({ name: homeName });
    } else if (!token && to.name === LOGIN_PAGE_NAME) {
        // 未登陆且要跳转的页面是登录页
        next();
    } else if (token && (!to.name || to.name === LOGIN_PAGE_NAME)) {
        // 已登录且要跳转的页面是登录页
        initCurrentUser(to, next, () => {next({ name: homeName })});// 跳转到homeName页
        
    } else {
        initCurrentUser(to, next, () => { turnTo(to,next)});
    }
});

router.afterEach(to => {
    menuRouteHelper.setTitle(to, router.app)
    LoadingBar.finish()
    window.scrollTo(0, 0)
});


export default router